const SearchConfig = {
  DEFAULT_SORT: "low_price asc",
  DEFAULT_PAGE_SIZE: 40,
  //	DEFAULT_IS_SEARCH: true
}

export default SearchConfig
